import { render } from "./amazonec2.vue?vue&type=template&id=14760ac6&scoped=true"
import script from "./amazonec2.vue?vue&type=script&lang=js"
export * from "./amazonec2.vue?vue&type=script&lang=js"

import "./amazonec2.vue?vue&type=style&index=0&id=14760ac6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14760ac6"]])

export default __exports__